var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('NavBar'),_c('div',{staticClass:"container main-container"},[_c('OrderList',{attrs:{"orders":_vm.$store.state.orders,"type":'MY_ORDERS'}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }